import { Directive, HostListener, ElementRef, Renderer2 } from "@angular/core";
import { formatPhoneNumber } from "./telephone-formatter.utils";

@Directive({
    selector: "input[kno2TelephoneFormatter]",
    exportAs: "kno2TelephoneFormatter",
    standalone: false
})
export class TelephoneFormatterDirective {
    private formatPhoneNumber = formatPhoneNumber;

    @HostListener("keypress", ["$event"])
    public onKeydown(event: KeyboardEvent): void {
        const pattern = /[0-9]/,
            validCodes = [
                8, // backspace
                13 // enter
            ];

        const code = event.keyCode;
        if (!code || validCodes.includes(code)) return;

        const char = String.fromCharCode(code);
        const inputEl = this.host.nativeElement as HTMLInputElement;

        if (!pattern.test(char) || inputEl.value.length >= 12) event.preventDefault();
    }

    @HostListener("ngModelChange")
    public onChange(): void {
        const inputEl = this.host.nativeElement as HTMLInputElement;
        const newInput = inputEl.value;
        this.renderer.setProperty(inputEl, "value", this.formatPhoneNumber(newInput));
    }

    constructor(
        private renderer: Renderer2,
        private host: ElementRef
    ) {}
}
